import React, { useState,useEffect } from 'react'
import { storeAuthToken, storeOrganizerId, storeUserDetails } from '../../utils/auth'
import { Link, useNavigate } from 'react-router-dom'
import { loginRequestOTP, userLogin,loginVerifyOTP, organizerBypassLogin } from '../../api'
import { useDispatch } from 'react-redux'
import { OtpPinInput } from '../../components/OtpPinInput';
type BypassLoginProps = {}

const BypassLogin = (props: BypassLoginProps) => {
	const dispatch = useDispatch();
	let navigate = useNavigate()
	const [username, setUsername] = useState("")
	const [password, setPassword] = useState("")
	const [errorMsg, setErrorMsg] = useState("")
	const [isLoading, setIsLoading] = useState(false)
	const [showPassword, setShowPassword] = useState(false)
  const [loginWithPassword, setLoginWithPassword] = useState(true) 
  const [otp, setOtp] = useState("")
  const [timer, setTimer] = useState(0);
  const [otpSent, setOtpSent] = useState(false);
  const [registrationId, setRegistrationId] = useState<string | null>(null);
  const [email,setEmail] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const handleSendOtp = async () => {
    if (!username) {
      setErrorMsg("Please enter your email");
      return;
    }
    try {
      setLoading(true);
      setError("");
      const response = await loginRequestOTP({ email: username });
      console.log("OTP request response:", response);
    if (response.registrationId) {
          setRegistrationId(response.registrationId);
        }
    if(response.email){
      setEmail(response.email);
    }
      setOtpSent(true);
      setTimer(60);
    } catch (err:any) {
      console.error("Failed to request OTP:", err);
      setError(err.response?.data?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };
  const handleResendOtp = async () => {
    if (!username) {
      setErrorMsg("Please enter your email");
      return;
    }
    try {
      setLoading(true);
      setError("");
      const response = await loginRequestOTP({ email: username });
      console.log("OTP request response:", response);
      if (response.registrationId) {
        setRegistrationId(response.registrationId);
      }
      setTimer(60);
    } catch (err:any) {
      console.error("Failed to request OTP:", err);
      setError(err.response?.data?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    let interval: NodeJS.Timeout;
    if (otpSent && timer > 0) {
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [otpSent, timer]);
  useEffect(() => {
    const storedToken = localStorage.getItem('authToken');
    if (storedToken) {
      navigate('/home');
    }
  }, [navigate]);
  const onClickOtpLogin =async () => {
    if (!registrationId) {
      setErrorMsg("Invalid registration. Please request OTP again.");
      return;
    }
    if (otp.length !== 6) {
      setErrorMsg("Please enter a valid 6-digit OTP.");
      return;
    }
    setIsLoading(true)
    console.log("OTP Login button clicked")
    let data = {
      email: username,
      "registrationId": registrationId,
      "otp": otp
    }
    try {
      const response: any = await loginVerifyOTP(data);
      if (response) { 
        const userRole = response.user.userRole;
        console.log("Login success", response)
        storeAuthToken(response.token)
        storeUserDetails(response.user)
        storeOrganizerId(Number(response?.user?.userId))
        if (userRole === "4" ) {
          const eventId = response.user.venue.event.eventId;
          const venueId = response.user.venue.venueId;
          const eventData = response.user.venue.event;
          const userData = response.user;
          localStorage.setItem("eventData", JSON.stringify(eventData));
            if (venueId ) {
              localStorage.setItem("venueId", venueId);
              localStorage.setItem("userData", JSON.stringify(userData));
            }
          if (eventId) {
                navigate(`/venue-event/${eventId}`);
            } 
            
          }
          else {
                navigate('/home');
           }	
        }

    } catch (e:any) {
      if(e?.response?.data){
        setErrorMsg(e?.response?.data.message)
      }
      console.log("Login failed", e)
    }finally{
      setIsLoading(false)
    }
  }
	const onClickLogin =async () => {
		setIsLoading(true)
		console.log("Login button clicked")
		let data = {
			"username": username,
			"password": password
		}
		try {
			const response: any = await organizerBypassLogin(data);
			if (response) { 
        const userRole = response.user.userRole;
				console.log("Login success", response)
				storeAuthToken(response.token)
        storeUserDetails(response.user)
				storeOrganizerId(Number(response?.user?.userId))
        if (userRole === "4" ) {
          const eventId = response.user.venue.event.eventId;
          const venueId = response.user.venue.venueId;
          const eventData = response.user.venue.event;
          const userData = response.user;
          localStorage.setItem("eventData", JSON.stringify(eventData));
            if (venueId ) {
              localStorage.setItem("venueId", venueId);
              localStorage.setItem("userData", JSON.stringify(userData));
            }
          if (eventId) {
                navigate(`/venue-event/${eventId}`);
            } 
            
          }
          else {
                navigate('/home');
           }	
        }

		} catch (e:any) {
			if(e?.response?.data){
				setErrorMsg(e?.response?.data.message)
			}
			console.log("Login failed", e)
		}finally{
			setIsLoading(false)
		}
	}
	return (
    <div className="form-wrapper">
      <div className="app-form">
        <div className="app-form-sidebar">
          <div className="sidebar-sign-logo">
            <img src="images/sign-logo.svg" alt="" />
          </div>
          <div className="sign_sidebar_text">
            <h1>
              The Easiest Way to Create Events and Sell More Tickets Online
            </h1>
          </div>
        </div>
        <div className="app-form-content">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-10 col-md-10">
                <div className="app-top-items">
                  <a href="index.html">
                    <div className="sign-logo" id="logo">
                      <img src="images/logo.svg" alt="" />
                      <img
                        className="logo-inverse"
                        src="images/dark-logo.svg"
                        alt=""
                      />
                    </div>
                  </a>
                 
                </div>  
              </div>
              <div className="col-xl-5 col-lg-6 col-md-7">
                <div className="registration">
                  <h2 className="registration-title">Admin Sign in to EventoX</h2>
                  <div className="form-group mt-5">
                    <label className="form-label">Venue Email*</label>
                    <input
                      className="form-control h_50"
                      type="email"
                      placeholder="Enter your email"
                      value={username}
                      onChange={(e) => setUsername(e.target.value)}
                    />
                  </div>
                  {error}
                  <div className="form-group mt-4">
                  {loginWithPassword ? (
                    <div className="form-group mt-4">
                      <div className="field-password">
                        <label className="form-label">Password*</label>
                       
                      </div>
                      <div className="loc-group position-relative">
                        <input
                          className="form-control h_50"
                          type={showPassword ? "text" : "password"}
                          placeholder="Enter your password"
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                        />
                        <span
                          className="pass-show-eye"
                          onClick={() => setShowPassword(!showPassword)}
                        >
                          <i className="fas fa-eye-slash"></i>
                        </span>
                      </div>
                       <div
                    className="gradient-button mt-4 text-center"
                    onClick={(e) => {
                      e.preventDefault();
                      onClickLogin()}
                    }
                  >
                    {isLoading ? "Loading..." : "Sign In"}{" "}
                    <i className="fas fa-sign-in-alt ms-2"></i>
                  </div>
                  <p className="error-msg">{errorMsg}</p>
                    </div>
                  ) : (
                    <div className="form-group mt-4 text-center">
                      {!otpSent ? (
                        <button
                          className="gradient-button"
                          type="button"
                          onClick={(e) => {
                            e.preventDefault();
                            handleSendOtp()}
                          }
                        >
                          {isLoading ? "Sending OTP..." : "Send OTP"}{" "}
                        </button>
                      ) : (
                        <>
                          <label className="form-label">Enter OTP*</label>
                          <OtpPinInput
                            value={otp}
                            onChange={setOtp}
                            boxStyle={{
                              border: "2px solid #ccc",
                              background: "#fff",
                              color: "#111",
                            }}
                          />
                          <div className="mt-3 text-center">
                            {timer > 0 ? (
                              <p className="text-muted">Re-send available in {timer}s</p>
                            ) : (
                              <p>
                                Didn’t receive code?{" "}
                                <span
                                  className="text-primary"
                                  style={{ cursor: "pointer", fontWeight: "500" }}
                                  onClick={handleResendOtp}
                                >
                                  Resend
                                </span>
                              </p>
                            )}
                          </div>
                           <div
                          className="gradient-button mt-4 text-center"
                          onClick={(e) => {
                            e.preventDefault();
                            onClickOtpLogin()}
                          }
                        >
                          {isLoading ? "Loading..." : "Sign In"}{" "}
                          <i className="fas fa-sign-in-alt ms-2"></i>
                        </div>
                        <p className="error-msg">{errorMsg}</p>
                              </>
                            )}
                          </div>
                  )}
                 
                  </div>
                  
                 
                </div>
              </div>
            </div>
          </div>
          <div className="copyright-footer">
            © {new Date().getFullYear()}, Eventox. All rights reserved.
          </div>
        </div>
      </div>
    </div>
  );
}

export default BypassLogin